import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    snackWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: theme.primary800,
      color: theme.white50,
      minHeight: "38px",
      padding: theme.spacing(3, 8),
      borderRadius: "4px",
      boxShadow:
        "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 11px 0px rgba(0, 0, 0, 0.14), 0px 3px 7px -1px rgba(0, 0, 0, 0.20)",
    },
    iconClose: {
      width: "20px",
      padding: 0,
      marginLeft: `${theme.spacing(8)} !important`,
      borderRadius: "4px",
      transition: "0.3s",

      "&:hover": {
        borderRadius: "4px",
        background: theme.gray100,
      },
    },
    snackbarButton: {
      textDecoration: "underline",
      color: theme.white50,
      fontSize: 13,
      fontWeight: 500,
      padding: 0,
      minWidth: 0,
      marginLeft: theme.spacing(8),

      "&:hover": {
        color: theme.gray300,
        textDecoration: "underline",
      },
    },
    text: {
      fontSize: "14px",
    },
    snackbar: {
      justifyContent: "flex-end",
      "& .MuiSnackbarContent-action": {
        "[dir='rtl'] &": {
          paddingLeft: 0,
          paddingRight: theme.spacing(8),
        },
      },
    },
  }),
);
